import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  activeLevelsImage, annualLicenseImage, referralBonusProgramImage, 
} from 'assets/images';

import styles from './styles.module.scss';

export const ReferralBonusContainer = memo(() => {
  const { t } = useTranslation('welcome');

  return (
    <div
      id="what-we-offer"
      className={styles.referral_container}
    >
      <div className={styles.referral_title}>
        <p className={styles.referral_title_first_part}>{t('Referral_title_')}</p>
        <span className={styles.referral_title_second_part}>{t('Referral_title_part2_')}</span>
      </div>
      <div className={styles.referral_content}>
        <div className={styles.referral_content_left}>
          <div className={styles.referral_content_left_subtitle}>
            <img
              loading="lazy"
              alt={t('Referral_li_1_')}
              src={annualLicenseImage}
            />
            <p>{t('Referral_li_1_')}</p>
          </div>
          <div className={styles.referral_content_left_subtitle}>
            <img
              loading="lazy"
              alt={t('Referral_li_2_')}
              src={activeLevelsImage}
            />
            <p>{t('Referral_li_2_')}</p>
          </div>
        </div>
        <img
          loading="lazy"
          className={styles.referral_content_right}
          alt=""
          src={referralBonusProgramImage}
        />
      </div>
    </div>
  );
});
